import axios from "axios";

const API_URL = process.env.REACT_APP_TOURISM_API_URL;

const API_TOKEN_ACCESS = process.env.REACT_APP_TOURISM_API_TOKEN_ACCESS;

const axiosInstance = axios.create({ baseURL: API_URL || "" });

// Request interceptor for API calls
axiosInstance.interceptors.request.use(
  async (config) => {
    config.headers = {
      Authorization: `Token ${API_TOKEN_ACCESS}`,
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) =>
//     Promise.reject(
//       (error.response && error.response.data) || "Error cliente axios"
//     )
// );

// Response interceptor for API calls
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      axios.defaults.headers.common["Authorization"] =
        "Token " + API_TOKEN_ACCESS;
      return axiosInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
